import { doc, getDoc } from 'firebase/firestore';

import { db } from '../../../firebase-config';
import { GATEWAY_STATUS } from '../../../utils/constants';

/**
 * Get the payment gateway status from Firebase
 * @returns {Promise<{status: string, message: string, estimatedDowntimeUntil: string}>} - Payment gateway status information
 */
export const getPaymentGatewayStatus = async () => {
  try {
    const paymentData = (await getDoc(doc(db, 'public', 'payment_data'))).data() || {};
    const gatewayConfig = paymentData.gateway || {};

    return {
      status: gatewayConfig.status || GATEWAY_STATUS.ONLINE,
      message: gatewayConfig.message || '',
      estimatedDowntimeUntil: gatewayConfig.estimatedDowntimeUntil || '',
    };
  } catch (error) {
    // Default to online if there's an error to prevent blocking payments
    return {
      status: GATEWAY_STATUS.ONLINE,
      message: '',
      estimatedDowntimeUntil: '',
    };
  }
};
